import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import { useParams } from "react-router-dom";
import buscar_azul from "../../images/search_azul.png";
import fotoPerfilDefault from "../../images/user.png";
import { Preloader } from "../../components/Preloader";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ModalSolicitudMensaje } from "../../components/empresa_uno_comp/ModalSolicitudMensaje";
import { ApiService } from "../../components/ApiService";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { Avatar, IconButton, Stack } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import MessageRoundedIcon from "@mui/icons-material/MessageRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Tooltip from "@mui/material/Tooltip";
import { useCompanyAssigned } from "../../components/CompanyAssignedContext";
import LupaIcon from "../../svg/lupaIcon";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";


export const SolicitudesClientes = ({
	selectedSucursal,
	permisos,
	myRoll,
	loadImageS
}) => {
	const [clientes, setClientes] = useState([]);
	const [filteredClientes, setFilteredClientes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedUser, setSelectedUser] = useState({});
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	let authCode = "";

	const apiUrl = process.env.REACT_APP_API_URL;
	const handleOpenModal = (user) => {
		setSelectedUser(user);
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const prepareDataForGrid = (data) => {
		return data.map((item, index) => ({
			...item,
			id: item.authCode || `row-${index}`,
		}));
	};
	const renderImage = (url) => {
		if (url !== null && url !== "") {
			return <Avatar src={`${apiUrl}${url}`} sx={{ width: 50, height: 50, mb: 1 }} />;
		}
		return <Avatar src={fotoPerfilDefault} alt="Usuario" sx={{ width: 50, height: 50, mb: 1 }} />;
	};

	useEffect(() => {
		const fetchClientes = async () => {
			setLoading(true);
			try {
				const url = `api/company/clients/requests?key_branch=${selectedSucursal}`;
				const options = { method: "GET" };
				const response = await ApiService.fetchData(url, options);
				if (!response) {
					throw new Error("Error al cargar las solicitudes de clientes");
				}

				setClientes(response);
				setFilteredClientes(response);
			} catch (error) {
				console.error("Error al cargar las solicitudes de clientes:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchClientes();
	}, [authCode]);
	const getDataGridColumns = () => [
		{
			field: "fullName",
			headerName: "Cliente",
			flex: 1,
		},
		{
			field: "profile",
			headerName: "Foto",
			align: "center",
			headerAlign: "center",
			flex: 1,
			sortable: false,
			renderCell: (params) => (
				<Box
					sx={{
						justifyContent: "center",
						width: "100%",
						alignItems: "center",
						height: "100%", // Add this to make Stack take full height
						display: "flex", // Ensure flex display is explicitly set
					}}>
					{renderImage(params.row.profile_url)}
				</Box>
			),
		},
		{
			field: "date",
			headerName: "Fecha",
			flex: 1,
		},
		{
			field: "phone",
			headerName: "Teléfono",
			flex: 1,
			renderCell: (params) => (
				<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<span>{params.row.phone || "Sin teléfono"}</span>
					{params.row.phone && (
						<a
							href={`https://wa.me/${params.row.codePhone}${params.row.phone}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{
								backgroundColor: "#25D366",
								borderRadius: "50%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "24px",
								height: "24px",
								textDecoration: "none",
							}}>
							<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
						</a>
					)}
				</div>
			),
		},
		{
			field: "location",
			headerName: "Ubicación",
			flex: 1,
		},
		{
			field: "mensaje",
			headerName: "Mensaje",
			align: "center",
			headerAlign: "center",
			flex: 1,
			sortable: false,
			renderCell: (params) => (
				<Tooltip title={"Ver mensaje"}>
					<IconButton
						onClick={(event) => {
							event.stopPropagation();
							handleOpenModal(params.row);
						}}>
						<MessageRoundedIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			field: "actions",
			headerName: "Acciones",
			sortable: false,
			align: "center",
			headerAlign: "center",
			flex: 1,
			renderCell: (params) => (
				<Stack
					direction="row"
					spacing={1}
					justifyContent="center"
					alignItems="center"
					sx={{
						width: "100%",
						height: "100%", // Add this to make Stack take full height
						display: "flex", // Ensure flex display is explicitly set
					}}>
					{
						permisos?.edit && (<>
							<Tooltip title={"Aprobar solicitud"}>
								<IconButton
									onClick={(event) => {
										event.stopPropagation();
										update_state(params.row.authCode, true);
									}}
									color="success">
									<CheckCircleRoundedIcon />
								</IconButton>
							</Tooltip>
							<Tooltip title={"Rechazar solicitud"}>
								<IconButton
									onClick={(event) => {
										event.stopPropagation();
										update_state(params.row.authCode, false);
									}}
									color="error">
									<CancelRoundedIcon />
								</IconButton>
							</Tooltip>
						</>)
					}

				</Stack>
			),
		},
	];
	async function update_state(code, bool) {
		const code_client = String(code || "");
		const reset_bool = !!bool;

		if (code_client.length !== 45) {
			toast.error("Código de solicitud inválido. Intenta refrescar la página");
			return;
		}

		const response = await ApiService.fetchData(
			`api/company/clients/${reset_bool ? "update" : "delete"}-discount?key_branch=${selectedSucursal}`,
			{
				method: reset_bool ? "PUT" : "DELETE",
				body: JSON.stringify({
					client: code_client,
					action: reset_bool,
				}),
			}
		);

		const data = await response;

		if (data == null) {
			toast.error("Error de solicitud");
		} else {
			toast.success(data.message);
		}

		const resetList = clientes.filter((obj, index_obj) => obj.authCode !== code_client);

		setClientes(resetList);
		setFilteredClientes(resetList);
	}

	function search_client(e) {
		const text_input = String(e.target.value).trim();

		const filtered = clientes.filter(
			(cliente) =>
				cliente.fullName.toLowerCase().includes(text_input.toLowerCase()) || cliente.phone.includes(text_input)
		);

		setFilteredClientes(filtered);
	}

	const resultRequesComponent = (authCode) => {
		if (!permisos?.edit) return (<></>);

		return (
			<>
				<Tooltip title={"Aprobar solicitud"}>
					<IconButton
						onClick={(event) => {
							event.stopPropagation();
							update_state(authCode, true);
						}}
						color="success">
						<CheckCircleRoundedIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title={"Rechazar solicitud"}>
					<IconButton
						onClick={(event) => {
							event.stopPropagation();
							update_state(authCode, false);
						}}
						color="error">
						<CancelRoundedIcon />
					</IconButton>
				</Tooltip>
			</>
		)
	}

	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Solicitudes de clientes</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} setValor={search_client} placeholder="Solicides"/>

				{/* <div className="content-btn-add" style={{ visibility: "hidden" }}>
					<button className="btn-add-var">
						<span className="txt-add">Nuevo Cliente</span>
					</button>
				</div> */}
			</div>

			<div className="datatable-container">
				{loading ? (
					<Preloader />
				) : (
					currentSize > 480 ? (
						<div className="table-view-pc">
							<Box sx={{ width: "100%", height: "calc(100vh - 200px)" }}>
								<DataGrid
									density={"comfortable"}
									rows={prepareDataForGrid(filteredClientes)}
									columns={getDataGridColumns()}
									initialState={{
										pagination: {
											paginationModel: { pageSize: 10, page: 0 },
										},
									}}
									pageSizeOptions={[5, 10, 25, 50]}
									pagination
									localeText={{
										MuiTablePagination: {
											labelRowsPerPage: "Filas por pagina:",
											labelDisplayedRows: ({ from, to, count }) =>
												`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
										},
									}}
									disableColumnMenu={true}
									disableRowSelectionOnClick
									slots={{
										noRowsOverlay: () => (
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													justifyContent: "center",
													height: "100%",
												}}>
												<VisibilityOffRoundedIcon
													sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
												/>
												<Typography variant="h6" color="textSecondary">
													No hay solicitudes disponibles
												</Typography>
											</Box>
										),
									}}
									sx={{
										"& .MuiDataGrid-columnHeader": {
											backgroundColor: 'var(--theme-company)',
											color: "white",
											fontWeight: "bold",
										},
									}}
								/>
							</Box>
						</div>
					) : (
						<TablesMobile loadImageS = { loadImageS } itsCompany={false}  filteredData={(filteredClientes ?? []).map(obj => ({
							img: obj?.profile_url,
							title: obj?.fullName,
							texto: obj?.user_message,
							fullPhone: obj?.codePhone + obj?.phone,
							authCode: obj?.authCode,
						}))} profile={true} type={'profile'} functionEspecial={resultRequesComponent} />
					)
				)}
			</div >

			{isModalOpen && <ModalSolicitudMensaje onClose={handleCloseModal} user={selectedUser} />
			}
		</>
	);
};
